const UPDATE = 'modules/manageOverflowScroll/UPDATE';

const reducer = (state = 'touch', action) => {
  switch (action.type) {
    case UPDATE:
      return action.value;
    default:
      return state;
  }
};

const updateOverflowScroll = (value) => {
  return {
    type: UPDATE,
    value,
  };
};

export { reducer as default, updateOverflowScroll };
